<template>
  <div>
    <h4>{{ title }}</h4>
    <div
      :class="{ 'flex-column': viewStyle === 'list' }"
      class="d-flex flex-wrap"
    >
      <div
        v-for="(val, index) in dataShortcut"
        :key="index"
        :class="`${viewStyle === 'list' ? 'list-of-shortcut' : 'grid-of-shortcut'}`"
      >
        <img :src="val.icon">
        <span>{{ val.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    dataShortcut() {
      return JSON.parse(this.element.info).shortcut;
    },

    viewStyle() {
      return JSON.parse(this.element.info).view_style;
    },

    title() {
      return JSON.parse(this.element.info).name;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-card/jShortcutPageWidget.vue